export default __webpack_public_path__ + "static/media/404-light.b8d005ff.svg";